import { render, staticRenderFns } from "./NotePopUp.vue?vue&type=template&id=c53d62e2&"
import script from "./NotePopUp.vue?vue&type=script&lang=js&"
export * from "./NotePopUp.vue?vue&type=script&lang=js&"
import style0 from "./NotePopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports